export const isImageType = type => {
  return (
    type === 'jpeg' ||
    type === 'png' ||
    type === 'jpg' ||
    type === 'webp' ||
    type === 'gif'
  )
}

export const isVideoType = type => {
  return (
    type === 'mp4' ||
    type === 'quicktime'
  )
}